import { Typography } from 'antd';
import { isNil, noop } from 'lodash';
import React, { useEffect, useState } from 'react';
import AppSearchInput from './AppSearchInput';
import { useModalState } from '../hooks/useModalState';
import AssetSearchModal from './AssetSearchModal';
import AssetDetails from 'pages/Asset/AssetDetail';

export type AssetSelectedType = {
  assetid?: number;
  assetreference?: string;
  assetlabel?: string;
};

export type AssetSelectProps = {
  onChange?: any;
  value?: AssetSelectedType;
  onlyAssetId?: boolean;
  clear?: boolean;
  isCreate?: boolean;
  display?: boolean;
  onCancel?: () => void;
  valueToDisplay?: AssetSelectedType;
  ctref?: string;
  phase?:any
};

const AssetSelect = ({
  ctref,
  onChange = noop,
  value,
  onlyAssetId,
  clear,
  isCreate,
  onCancel,
  display,
  valueToDisplay,
  phase,
}: AssetSelectProps) => {
  const [Params, setParams] = useState<AssetSelectedType>({
    assetid: value?.assetid,
    assetreference: value?.assetreference,
    assetlabel: value?.assetlabel,
  });

  const { visible, close, open } = useModalState(false);

  const [onClear, setOnClear] = useState(false);

  const handleSelect = (item: any) => {
    onlyAssetId ? onChange(item.assetid) : onChange(item);

    setParams({
      assetreference: item?.assetreference,
      assetlabel: item.assetlabel,
      assetid: item?.assetid,
    });
    close();
    setOnClear(true);
  };
  const handleClear = () => {

    // Clear the input and reset Params
    setParams({
      assetreference: undefined,
      assetlabel: undefined,
      assetid: undefined,
    });
    onChange(undefined); // Notify parent of cleared state
  };
  useEffect(() => {
    setOnClear(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if ((typeof value === 'number') && value === 0) {
      setParams({
        assetreference: undefined,
        assetlabel: undefined,
        assetid: undefined,
      })
    }
  }, [clear,value]);
  const [visibleModal, setvisibleModal] = useState(false);

  return (
    <>
      {display ? (
        <Typography.Link
        style={{borderRadius:"10px"}}
          onClick={() => {
            setvisibleModal(true);
          }}
          title="Open details"
          ellipsis
        >
          {valueToDisplay?.assetid
            ? `${valueToDisplay.assetreference ?? ''} - ${
                valueToDisplay.assetlabel ?? ''
              } `
            : onlyAssetId && !value?.assetid
            ? Params?.assetid
              ? `${Params.assetlabel ?? ''} `
              : isCreate
              ? 'Create an Asset....'
              : 'Select an Asset'
            : value?.assetid
            ? `${value.assetlabel ?? ''} `
            : isCreate
            ? 'Create an Asset....'
            : Params?.assetid
            ? `${Params.assetlabel ?? ''} `
            : 'Select an Asset'}
        </Typography.Link>
      ) : (
        <AppSearchInput
          onSearch={() => {
            open();
            localStorage.removeItem('searchParams');
            localStorage.removeItem('searchParams_components');
            }}
            onClear={handleClear} // Update the onClear handler
          value={
            <Typography.Link
              onClick={() => {
                setvisibleModal(true);
              }}
            >
              {onClear && !value?.assetid
                ? Params?.assetid && value !== undefined && !isNil(value)
                  ? `${Params.assetreference ?? ''}  -  ${
                      Params.assetlabel ?? ''
                    }`
                  : 'Select an Asset'
                : value?.assetid && value !== undefined && !isNil(value)
                ? `${value.assetreference ?? ''}  -  ${value.assetlabel ?? ''}`
                : 'Select an Asset'}
            </Typography.Link>
          }
        />
      )}
      <AssetSearchModal
        visible={visible}
        onCancel={close}
        setAsset={handleSelect}
        ctref={ctref}
        phase={phase}
      />
      {value?.assetid || Params.assetid || isCreate ? (
        <AssetDetails
          assetid={onlyAssetId ? Number(value) ?? 0 : value?.assetid ?? 0}
          visible={visibleModal}
          onCancel={() => setvisibleModal(false)}
          showAsModal
          hideSaveBtn
          phaseprop="PROPOSAL"
          iscreate={false}
        />
      ) : (
        ''
      )}
    </>
  );
};

export default AssetSelect;
